<template>
  <div
    v-if="selectedDa"
    class="brands-list"
  >
    <template>
      <div>
        <section id="all" class="main_section product-section ratio_85 pt-0">
              <div class="container">
                <div class="row custom-col-cls infinite-loader-sec">
                  <template v-for="(brand, brand_index) in getFilteredBrands">
                    <BrandTile :key="brand_index" :brand="brand" v-if="!brand[siteDomain + '_multi_brand']" /><StoreBrandTile v-else :brand="brand" v-for="(store, index) in getDeliverableStoresForBrand(brand._id)"
                                      :key="index + store._id" :store="store"/>
                  </template>
                </div>
              </div>
        </section>
      </div>
    </template>

    <template v-for="(offer, key) in availableGoorderTypes">
      <div :key="'offer' + key" v-if="getFilteredBrandsByOfferType(offer.name).length">
        <section
          class="main_section product-section ratio_85 pt-0"
          :id="getId(offer.name)"
        >
          <div class="container">
            <div class="row custom-col-cls infinite-loader-sec">
              <!--<BrandTile
                v-for="brand in shown_brands(offer.name)"
                :key="brand.id"
                :brand="brand"
              />-->
              <template v-for="brand in getFilteredBrandsByOfferType(offer.name)">
                <BrandTile :key="brand.id" :brand="brand" v-if="!brand[siteDomain + '_multi_brand']" />
                <StoreBrandTile v-else :brand="brand" v-for="(store, index) in getDeliverableStoresForBrand(brand._id)"
                                :key="index" :store="store"/>
              </template>
              <!-- <div class="col-12">
                <div
                  id="show-more1"
                  class="show-more-cls"
                  :class="{ 'no-more': noMore }"
                  v-if="getBrandsByType(offer.name).length>num_brands_displayed"
                  @click="loadMoreProducts"
                >
                  <a
                    href="javascript:void(0)"
                    class="btn btn-solid btn-pill"
                  >{{ _T('Show More') }}
                    <svg
                      class="rightarrow"
                      fill="none"
                    >
                      <use
                        class="fill-white"
                        xlink:href="#rightarrow"
                      />
                    </svg>
                  </a>
                </div>
              </div> -->
            </div>
          </div>
        </section>
      </div>
    </template>
    <store-picker />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BrandTile from '../Collections/BrandTile'
import StorePicker from '@/components/Collections/StorePicker'
import StoreBrandTile from "../Collections/StoreBrandTile";

export default {
  name: 'PopularBrands',
  components: {StoreBrandTile, BrandTile, StorePicker },
  computed: {
    ...mapGetters(['_T', '_T_DB', 'siteDomain', 'getBrandsByType', 'getFilteredBrands','getFilteredBrandsByOfferType',
      'all_brands_by_area', 'availableGoorderTypes', 'selectedDa', 'getDeliverableStoresForBrand']),
    
  },
  data () {
    return {
      num_brands_displayed: 8,
      noMore: false,
      firstBrand: false,
      storesBrands: false,
    }
  },
  mounted () {
    this.$store.dispatch('load_brands')
  },
  /*created () {
    this.$socket.$subscribe('online-order-channel', payload => {
      console.log('payload', payload)
    })
  },*/
  methods: {
    firstBrandSection() {
      if (!this.firstBrand) {
        this.firstBrand = true
        return true
      }
      return false
    },
    loadMoreProducts () {
      this.num_brands_displayed += 4
    },
    getId (data) {
      return data.split(' ').join('')
    },
  },
}
</script>

<style lang="scss" scoped>
.no-da-selected {
  padding: 2rem;
  font-size: $px24;
  text-align: center;
  color: $color-primary;
  font-weight: 600;
  display: flex;
  justify-content: space-around;
}
.rightarrow {
  width: $px16;
  height: $px16;
}
.brands-list {
  div {
    &:first-child {
      .product-section {
        padding-top: calc(
          30px + (80 - 30) * ((100vw - 320px) / (1920 - 320))
        ) !important;
      }
    }
  }
}
.brands-container {
  padding: 4rem;
  .brands-header {
    font-size: 2rem;
    padding-bottom: 4rem;
  }
}
@media (max-width: 767px) {
  .fixed-mp-cls {
    margin-bottom: $px60;
  }
}
@media (max-width: 575px) {
  .main_section {
    border-top: $px12 solid #edeff4;
    padding-top: $px16 !important;
    margin-top: $px16;
    margin-bottom: 0;
    min-height: 50vh !important;
  }
  .brands-list {
    > div {
      &:last-child {
        margin-bottom: $px60 !important;
      }
    }
  }
}
</style>
